"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactstrap = require("reactstrap/dist/reactstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _AlertConstants = _interopRequireDefault(require("../../constants/AlertConstants"));

var _this = void 0;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledAlert = (0, _styledComponents["default"])(_reactstrap.Alert).withConfig({
  displayName: "SelfClosingAlert__StyledAlert",
  componentId: "sc-1vw7dfe-0"
})(["&&&{background-color:", ";color:", ";border-color:", ";box-shadow:0 0 8px 0 rgba(0,0,0,0.2);}"], function (props) {
  return props.styles["background"];
}, function (props) {
  return props.styles["color"];
}, function (props) {
  return props.styles["border"];
});

var SelfClosingAlert = function SelfClosingAlert(_ref) {
  var type = _ref.type,
      text = _ref.text,
      id = _ref.id,
      onRemove = _ref.onRemove;
  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var DangerTheme = Theme["danger"];
  var SuccessTheme = Theme["success"];
  var WarningTheme = Theme["warning"];
  var InfoTheme = Theme["info"];

  var getTime = function getTime(type) {
    switch (type) {
      case _AlertConstants["default"].TYPES.SUCCESS:
        return 5000;

      case _AlertConstants["default"].TYPES.INFO:
        return 7000;

      case _AlertConstants["default"].TYPES.WARNING:
        return 10000;

      case _AlertConstants["default"].TYPES.DANGER:
      default:
        break;
    }
  };

  var getTheme = function getTheme(theme) {
    var themeStr = !!theme ? theme.toLowerCase() : "";

    switch (themeStr) {
      case _AlertConstants["default"].TYPES.DANGER:
        return DangerTheme;

      case _AlertConstants["default"].TYPES.WARNING:
        return WarningTheme;

      case _AlertConstants["default"].TYPES.INFO:
        return InfoTheme;

      case _AlertConstants["default"].TYPES.SUCCESS:
      default:
        return SuccessTheme;
    }
  };

  (0, _react.useEffect)(function () {
    var time = getTime(type);

    if (time) {
      startTimer(time);
    }
  }, []);

  var startTimer = function startTimer(time) {
    if (time) {
      delayedRemoval(id, time);
    }
  };

  var delayedRemoval = function delayedRemoval(id, time) {
    setTimeout(function () {
      removeAlertWithId(id);
    }.bind(_this), time);
  };

  var removeAlert = function removeAlert() {
    onRemove(id);
  };

  var removeAlertWithId = function removeAlertWithId(id) {
    onRemove(id);
  };

  var alertTheme = getTheme(type);
  return _react["default"].createElement(StyledAlert, {
    id: "styled-alert",
    color: type,
    toggle: removeAlert,
    styles: alertTheme,
    closeClassName: "best-alert-close-button"
  }, text);
};

SelfClosingAlert.propTypes = {
  /** id reference to alert */
  id: _propTypes["default"].string.isRequired,

  /** type of alert from Alert Constants */
  type: _propTypes["default"].string.isRequired,

  /** text to display in alert */
  text: _propTypes["default"].any.isRequired,

  /** function called when removing the alert with the ID */
  onRemove: _propTypes["default"].func.isRequired
};
var _default = SelfClosingAlert;
exports["default"] = _default;